<!-- footer Start -->
<section class="footer">
  <div class="svg-container">
    <svg viewBox="0 0 1440 127" fill="none" xmlns="http://www.w3.org/2000/svg">
      <ellipse cx="719.5" cy="-95" rx="808.5" ry="222" fill="#FAF5FF" />
    </svg>
  </div>
  <div class="container" style="margin-top:60px">
    <div class="row">
      <div class="col-md-12">
        <div class="text-center text-muted">
          <p class="mb-0 f-15 footer-text"> {{currentYear}} © Bemddops</p>
        </div>
      </div>
    </div>
    <div class="row justify-content-center">
      <div class="col-md-6 col-sm-12 text-center">
        <ul class="list-unstyled footer-social-list mt-4">
          <li class="list-inline-item"><a href="https://www.facebook.com/Bemddops-116478215127241/" target="_blank"> <i
                class="mdi mdi-facebook"></i></a></li>
          <li class="list-inline-item"><a href="https://instagram.com/bemddops?igshid=ZjA0NjI3M2I=" target="_blank"><i
                class="mdi mdi-instagram"></i></a></li>
          <li class="list-inline-item"><a href="https://www.linkedin.com/company/bemddops/" target="_blank"><i
                class="mdi mdi-linkedin"></i></a></li>
          <li class="list-inline-item"><a href="https://twitter.com/bemddops/" target="_blank"><i
                class="mdi mdi-twitter"></i></a></li>
          <li class="list-inline-item"><a href="https://www.youtube.com/channel/UCUyj6D3VfdK-DBdqCnQ1efA/featured"
              target="_blank"><i class="mdi mdi-youtube"></i></a></li>
        </ul>
      </div>
    </div>
  </div>
</section>
<!-- footer End -->
